import { isAgentHubEnabled } from 'agentHub/selectors/isAgentHubEnabled'
import { createSelector } from 'reselect'
import getDepositCalculations from './getDepositCalculations'

const getDepositServiceFee = createSelector(
  (state: App.State) => getDepositCalculations(state),
  (calculations): number => {
    return calculations.serviceFee
  },
)

/** Agent Hub waives deposit service fees in checkout UI (matches pay-in-full). */
export const getDepositServiceFeeForDisplay = createSelector(
  (state: App.State) => getDepositServiceFee(state),
  (fee) => (isAgentHubEnabled ? 0 : fee),
)

export default getDepositServiceFee
